<template>
    <div>
        <div class="avatar avatar-xxl" @click="uploadAvatar($event)">
            <img src="https://via.placeholder.com/350x150" alt="..." class="avatar-img rounded-circle">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Avatar',
        computed: {
            avatarImg() {
                return this.$store.getters.avatarImage;
            }
        },
        methods: {
            uploadAvatar(e) {
                let avatarContainer = e.currentTarget;
                let imgContainer = avatarContainer.childNodes[0];
                let input = `<input type="file" name="avatarUpload" id="avatarUpload" style="display: none">`;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/backend/profile/Avatar.vue